module.exports = __webpack_public_path__ + "img/20191031163122261.8b529ec1.jpg";